(function () {
  'use strict';

  if (window.DanfeeWishlist) return;

  var STORAGE_KEY = 'danfee:wishlist:v1';
  var MAX_ITEMS = 100;
  var FETCH_CONCURRENCY = 6;
  var TOAST_MS = 3500;

  var STRINGS = {
    en: {
      short: 'Wishlist',
      shortActive: 'Saved',
      add: 'Add to wishlist',
      remove: 'Remove from wishlist',
      saved: 'Saved to wishlist',
      removed: 'Removed from wishlist',
      view: 'View wishlist',
      label: 'Wishlist',
      title: 'My Wishlist',
      note: 'Your wishlist is saved in this browser.',
      empty: 'Your wishlist is empty.',
      browse: 'Continue shopping',
      error: "We couldn't load your wishlist. Please refresh the page.",
    },
    de: {
      short: 'Merken',
      shortActive: 'Gemerkt',
      add: 'Zur Wunschliste hinzufügen',
      remove: 'Von der Wunschliste entfernen',
      saved: 'Zur Wunschliste hinzugefügt',
      removed: 'Von der Wunschliste entfernt',
      view: 'Wunschliste ansehen',
      label: 'Wunschliste',
      title: 'Meine Wunschliste',
      note: 'Ihre Wunschliste wird in diesem Browser gespeichert.',
      empty: 'Ihre Wunschliste ist leer.',
      browse: 'Weiter einkaufen',
      error: 'Ihre Wunschliste konnte nicht geladen werden. Bitte laden Sie die Seite neu.',
    },
    fr: {
      short: 'Favoris',
      shortActive: 'Enregistré',
      add: 'Ajouter à la liste de souhaits',
      remove: 'Retirer de la liste de souhaits',
      saved: 'Ajouté à la liste de souhaits',
      removed: 'Retiré de la liste de souhaits',
      view: 'Voir la liste de souhaits',
      label: 'Liste de souhaits',
      title: 'Ma liste de souhaits',
      note: 'Votre liste de souhaits est enregistrée dans ce navigateur.',
      empty: 'Votre liste de souhaits est vide.',
      browse: 'Continuer mes achats',
      error: 'Impossible de charger votre liste de souhaits. Veuillez actualiser la page.',
    },
    it: {
      short: 'Preferiti',
      shortActive: 'Salvato',
      add: 'Aggiungi alla lista dei desideri',
      remove: 'Rimuovi dalla lista dei desideri',
      saved: 'Aggiunto alla lista dei desideri',
      removed: 'Rimosso dalla lista dei desideri',
      view: 'Vedi la lista dei desideri',
      label: 'Lista dei desideri',
      title: 'La mia lista dei desideri',
      note: 'La tua lista dei desideri è salvata in questo browser.',
      empty: 'La tua lista dei desideri è vuota.',
      browse: 'Continua lo shopping',
      error: 'Impossibile caricare la lista dei desideri. Aggiorna la pagina.',
    },
    ja: {
      short: 'お気に入り',
      shortActive: '追加済み',
      add: 'お気に入りに追加',
      remove: 'お気に入りから削除',
      saved: 'お気に入りに追加しました',
      removed: 'お気に入りから削除しました',
      view: 'お気に入りを見る',
      label: 'お気に入り',
      title: 'お気に入り',
      note: 'お気に入りはこのブラウザに保存されます。',
      empty: 'お気に入りはまだありません。',
      browse: '買い物を続ける',
      error: 'お気に入りを読み込めませんでした。ページを再読み込みしてください。',
    },
    nb: {
      short: 'Ønskeliste',
      shortActive: 'Lagret',
      add: 'Legg til i ønskelisten',
      remove: 'Fjern fra ønskelisten',
      saved: 'Lagt til i ønskelisten',
      removed: 'Fjernet fra ønskelisten',
      view: 'Se ønskelisten',
      label: 'Ønskeliste',
      title: 'Min ønskeliste',
      note: 'Ønskelisten din lagres i denne nettleseren.',
      empty: 'Ønskelisten din er tom.',
      browse: 'Fortsett å handle',
      error: 'Kunne ikke laste inn ønskelisten. Oppdater siden.',
    },
    zh: {
      short: '收藏',
      shortActive: '已收藏',
      add: '加入收藏',
      remove: '取消收藏',
      saved: '已加入收藏',
      removed: '已取消收藏',
      view: '查看收藏',
      label: '收藏',
      title: '我的收藏',
      note: '收藏內容保存在目前的瀏覽器中。',
      empty: '收藏夾還是空的。',
      browse: '繼續選購',
      error: '收藏載入失敗，請重新整理頁面。',
    },
  };

  var lang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  var t = STRINGS[lang] || STRINGS.en;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var WISHLIST_URL = root + 'pages/wishlist';
  var HEART =
    '<svg class="df-wishlist-heart" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.5s-7.5-4.6-9.3-9.2C1.5 8 3.6 4.8 6.9 4.8c2.1 0 3.9 1.1 5.1 3 1.2-1.9 3-3 5.1-3 3.3 0 5.4 3.2 4.2 6.5-1.8 4.6-9.3 9.2-9.3 9.2z"/>' +
    '</svg>';

  // Falls back to memory when browser storage is blocked (e.g. some private modes).
  var memoryItems = [];
  var storageAvailable = true;

  function isValidEntry(entry) {
    return entry && typeof entry.handle === 'string' && entry.handle.length > 0 && entry.handle.length <= 255;
  }

  function read() {
    if (!storageAvailable) return memoryItems.slice();
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter(isValidEntry) : [];
    } catch (error) {
      if (error instanceof SyntaxError) return [];
      storageAvailable = false;
      return memoryItems.slice();
    }
  }

  function write(items) {
    memoryItems = items.slice();
    if (!storageAvailable) return;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      storageAvailable = false;
    }
  }

  function has(handle) {
    return read().some(function (entry) {
      return entry.handle === handle;
    });
  }

  function add(handle) {
    var items = read().filter(function (entry) {
      return entry.handle !== handle;
    });
    items.unshift({ handle: handle, addedAt: Date.now() });
    write(items.slice(0, MAX_ITEMS));
    syncAll();
  }

  function remove(handle) {
    write(
      read().filter(function (entry) {
        return entry.handle !== handle;
      })
    );
    syncAll();
  }

  function setToggleState(button) {
    var active = has(button.dataset.handle);
    var label = active ? t.remove : t.add;
    var title = button.dataset.title;
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', title ? label + ': ' + title : label);
    button.classList.toggle('is-active', active);
    var text = button.querySelector('[data-df-wishlist-button-text]');
    if (text) text.textContent = active ? t.shortActive : t.short;
  }

  function syncToggles(root) {
    (root || document).querySelectorAll('[data-df-wishlist-toggle]').forEach(setToggleState);
  }

  function syncCounts() {
    var count = read().length;
    document.querySelectorAll('[data-df-wishlist-count]').forEach(function (element) {
      var next = count > 99 ? '99+' : String(count);
      if (element.textContent !== next) element.textContent = next;
      element.hidden = count === 0;
    });
    document.querySelectorAll('[data-df-wishlist-link]').forEach(function (link) {
      link.setAttribute('aria-label', count > 0 ? t.label + ' (' + count + ')' : t.label);
    });
  }

  function syncText() {
    document.querySelectorAll('[data-df-wishlist-text]').forEach(function (element) {
      var value = t[element.dataset.dfWishlistText];
      if (value) element.textContent = value;
    });
  }

  function syncAll() {
    syncToggles();
    syncCounts();
  }

  var toast;
  var toastTimer;

  function showToast(message, showLink) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'df-wishlist-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = '';
    var text = document.createElement('span');
    text.textContent = message;
    toast.appendChild(text);

    if (showLink) {
      var link = document.createElement('a');
      link.href = WISHLIST_URL;
      link.textContent = t.view;
      toast.appendChild(link);
    }

    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, TOAST_MS);
  }

  function setPageState(page, state) {
    page.dataset.state = state;
    page.querySelectorAll('[data-df-wishlist-state]').forEach(function (element) {
      element.hidden = element.dataset.dfWishlistState !== state;
    });
    var grid = page.querySelector('[data-df-wishlist-grid]');
    if (grid) grid.hidden = state !== 'ready';
  }

  function productViewUrl(handle) {
    return root + 'products/' + encodeURIComponent(handle) + '?view=wishlist-card';
  }

  function fetchCard(handle) {
    return window.fetch(productViewUrl(handle), { credentials: 'same-origin' }).then(function (response) {
      if (response.status === 404) return { handle: handle, gone: true };
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.text().then(function (html) {
        var template = document.createElement('template');
        template.innerHTML = html;
        // A theme without the wishlist-card view returns a full product page. Never treat that as a card.
        var card = template.content.querySelector('[data-df-wishlist-card]');
        if (!card) throw new Error('Wishlist card view is missing');
        card.dataset.handle = handle;
        return { handle: handle, card: card };
      });
    });
  }

  function loadAll(handles) {
    var results = new Array(handles.length);
    var nextIndex = 0;

    function worker() {
      if (nextIndex >= handles.length) return Promise.resolve();
      var index = nextIndex++;
      return fetchCard(handles[index])
        .then(function (result) {
          results[index] = result;
        })
        .catch(function () {
          results[index] = { handle: handles[index], failed: true };
        })
        .then(worker);
    }

    var workers = [];
    for (var i = 0; i < Math.min(FETCH_CONCURRENCY, handles.length); i++) workers.push(worker());
    return Promise.all(workers).then(function () {
      return results;
    });
  }

  function renderPage(page) {
    var grid = page.querySelector('[data-df-wishlist-grid]');
    if (!grid) return Promise.resolve();

    var handles = read().map(function (entry) {
      return entry.handle;
    });

    if (handles.length === 0) {
      grid.textContent = '';
      setPageState(page, 'empty');
      return Promise.resolve();
    }

    setPageState(page, 'loading');
    return loadAll(handles).then(function (results) {
      // Only a definite 404 removes an item. Temporary errors keep it saved for the next visit.
      var gone = results.filter(function (result) {
        return result.gone;
      });
      if (gone.length) {
        write(
          read().filter(function (entry) {
            return !gone.some(function (result) {
              return result.handle === entry.handle;
            });
          })
        );
      }

      grid.textContent = '';
      results.forEach(function (result) {
        // Skip anything the visitor removed while the cards were loading.
        if (result.card && has(result.handle)) grid.appendChild(result.card);
      });

      var anyFailed = results.some(function (result) {
        return result.failed;
      });
      if (grid.children.length) setPageState(page, 'ready');
      else setPageState(page, anyFailed ? 'error' : 'empty');
      syncAll();
    });
  }

  function removeCardFromPage(handle) {
    document.querySelectorAll('[data-df-wishlist-page]').forEach(function (page) {
      var grid = page.querySelector('[data-df-wishlist-grid]');
      if (!grid) return;
      grid.querySelectorAll('[data-df-wishlist-card]').forEach(function (card) {
        if (card.dataset.handle === handle) card.remove();
      });
      if (!grid.children.length && page.dataset.state === 'ready') setPageState(page, 'empty');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-df-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();

    var handle = button.dataset.handle;
    if (!handle) return;
    var onWishlistPage = Boolean(document.querySelector('[data-df-wishlist-page]'));

    if (has(handle)) {
      remove(handle);
      removeCardFromPage(handle);
      if (!onWishlistPage) showToast(t.removed, false);
    } else {
      add(handle);
      button.classList.remove('is-pop');
      void button.offsetWidth;
      button.classList.add('is-pop');
      if (!onWishlistPage) showToast(t.saved, true);
    }
  });

  // Keeps the page right when another tab changes the wishlist.
  window.addEventListener('storage', function (event) {
    if (event.key !== STORAGE_KEY && event.key !== null) return;
    syncAll();
    document.querySelectorAll('[data-df-wishlist-page]').forEach(renderPage);
  });

  // Back/forward cache can restore a page with an out-of-date wishlist.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) syncAll();
  });

  function handleFromUrl(url) {
    try {
      var match = new URL(url, window.location.origin).pathname.match(/\/products\/([^/]+)\/?$/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function createToggle(handle, title, modifier, withText) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'df-wishlist-toggle ' + modifier;
    button.setAttribute('data-df-wishlist-toggle', '');
    button.dataset.handle = handle;
    if (title) button.dataset.title = title;
    button.innerHTML = HEART + (withText ? '<span data-df-wishlist-button-text></span>' : '');
    setToggleState(button);
    return button;
  }

  function injectCardToggles() {
    document.querySelectorAll('.product-card-wrapper').forEach(function (wrapper) {
      if (wrapper.querySelector('[data-df-wishlist-toggle]')) return;
      if (wrapper.querySelector('.card--horizontal') || wrapper.closest('.quick-add-modal')) return;
      var link = wrapper.querySelector('.card__heading a[href*="/products/"]');
      var handle = link && handleFromUrl(link.getAttribute('href'));
      if (!handle) return;
      wrapper.appendChild(createToggle(handle, link.textContent.trim(), 'df-wishlist-toggle--card', false));
    });
  }

  function injectProductToggle() {
    document.querySelectorAll('product-info[data-url]').forEach(function (info) {
      if (info.closest('.quick-add-modal') || info.querySelector('.df-wishlist-toggle--product')) return;
      var submit = info.querySelector('[id^="ProductSubmitButton-"]');
      var form = submit && submit.closest('product-form');
      var handle = handleFromUrl(info.dataset.url);
      if (!form || !handle) return;
      var heading = info.querySelector('.product__title h1');
      var toggle = createToggle(handle, heading ? heading.textContent.trim() : '', 'df-wishlist-toggle--product', true);
      // Lines up under the quantity selector, with express checkout under the add to cart button.
      var payment = form.querySelector('.product-form__buttons > .shopify-payment-button');
      if (payment && form.querySelector('.df-quantity-cart-row')) {
        payment.parentElement.classList.add('df-wishlist-row');
        payment.insertAdjacentElement('beforebegin', toggle);
      } else {
        form.insertAdjacentElement('afterend', toggle);
      }
    });
  }

  function injectLinks() {
    var added = false;
    var cart = document.getElementById('cart-icon-bubble');
    if (cart && !document.querySelector('.df-wishlist-header')) {
      var headerLink = document.createElement('a');
      headerLink.href = WISHLIST_URL;
      headerLink.className = 'header__icon link focus-inset df-wishlist-header';
      headerLink.setAttribute('data-df-wishlist-link', '');
      headerLink.innerHTML =
        '<span class="svg-wrapper">' + HEART + '</span>' +
        '<span class="df-wishlist-count" data-df-wishlist-count hidden></span>';
      cart.parentNode.insertBefore(headerLink, cart);
      added = true;
    }
    var drawer = document.querySelector('.menu-drawer__utility-links');
    if (drawer && !drawer.querySelector('.df-wishlist-drawer-link')) {
      var drawerLink = document.createElement('a');
      drawerLink.href = WISHLIST_URL;
      drawerLink.className = 'df-wishlist-drawer-link link link--text focus-inset';
      drawerLink.setAttribute('data-df-wishlist-link', '');
      drawerLink.innerHTML =
        HEART + '<span data-df-wishlist-text="label"></span>' +
        '<span class="df-wishlist-count" data-df-wishlist-count hidden></span>';
      drawerLink.querySelector('[data-df-wishlist-text]').textContent = t.label;
      drawer.insertBefore(drawerLink, drawer.firstChild);
      added = true;
    }
    if (added) syncCounts();
  }

  function injectAll() {
    injectLinks();
    injectCardToggles();
    injectProductToggle();
  }

  // Product cards are replaced by filters, sorting, variant changes and recommendations.
  function observeNewContent() {
    if (!window.MutationObserver || !document.body) return;
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.setTimeout(function () {
        scheduled = false;
        injectAll();
      }, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    syncText();
    injectAll();
    syncAll();
    observeNewContent();
    document.querySelectorAll('[data-df-wishlist-page]').forEach(renderPage);
  }

  window.DanfeeWishlist = { has: has, add: add, remove: remove, read: read };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
